import axios from "axios";
import {authHeader} from "../helpers/auth-header";

/**
 * Get List
 * @param networkDeviceId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getScenes = (networkDeviceId) => {
    return axios.get(`/api/PxmModbus/GetList/${networkDeviceId}`, { headers: authHeader() })
        .then((res) => { return res.data })
}

const getSceneById = (sceneId) => {
    return axios.get(`/api/PxmModbus/GetById/${sceneId}`, { headers: authHeader() })
        .then((res) => { return res.data })
}

const createScene = (pxmModbusModel) => {
    return axios.post(`/api/PxmModbus`, pxmModbusModel, { headers: authHeader() })
        .then((res) => { return res.data });
}

const updateScene = (pxmModbusService, sceneId) => {
    return axios.patch(`/api/PxmModbus/${sceneId}`, pxmModbusService, { headers: authHeader()})
        .then((res) => { return res.data });
}

const deleteScene = (sceneId) => {
    return axios.delete(`/api/PxmModbus/${sceneId}`, { headers: authHeader() })
        .then((res) => { return res.data });
}

export const pxmModbusService = {
    getScenes,
    getSceneById,
    createScene,
    updateScene,
    deleteScene
}
